<script>
import Page from "./include/Page.vue";
import Languages from "../lang/lang";

export default {
  name: "SectionFarmOrders",
  components: {Page},
  data: function() {
    return {
      result: null,
      dataLoading: false,
      formatDay: window['formatDay'],
      startDateValue: window['xive']['userData'].startDate,
      endDateValue: window['xive']['userData'].endDate,
      formatBigDollar: window['formatBigDollar'],
      setPage(page) {
        let params = new URLSearchParams({
          startDate: this.startDateValue,
          endDate: this.endDateValue,
          page: page,
          pageSize: 10,
        });
        this.dataLoading = true;
        fetch(window['API_URL'] + '/api/v4/client/group-mining/' + this.farmId + '/orders?' + params, {
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
          }
        }).then(res => res.json())
            .then(res => {
              this.result = res.data;
              this.dataLoading = false;
            });
      }
    }
  },
  computed: {
    lang() {
      return Languages.texts('farmOrders');
    },
    tableLang() {
      return Languages.texts('table');
    },
    generalLang() {
      return Languages.texts('general');
    },
  },
  props: ['farmId'],
  mounted() {
    window.scrollTo(0, 0);
    this.setPage(0);
  }
}
</script>

<template>
  <div>
    <div class="back-link">
      <router-link :to="'/farm/' + farmId">{{ generalLang['backFarm'] }}</router-link>
    </div>
    <div class="table-section">
      <div class="block-title">
        {{ lang['title'] }}:
      </div>
      <div class="dates">
        <div class="date-selectors">
          <input type="date" class="date-start" v-model="startDateValue" @change="setPage(0)"/>
          <input type="date" class="date-end" v-model="endDateValue" @change="setPage(0)"/>
          <div class="total">
            {{ tableLang['total'] }}:
            <b v-if="result != null">{{ formatBigDollar(result.summary) }}</b>
            <b v-if="result == null">---</b>
          </div>
        </div>
      </div>
      <div class="table table-farm-orders wide" data-table="income-four">
        <div class="th">
          {{ lang['date'] }}
        </div>
        <div class="th">
          {{ lang['stake'] }}
        </div>
        <div class="th">
          {{ lang['amount'] }}
        </div>
        <div class="th">
          {{ lang['deposit'] }}
        </div>

        <div class="table-loading" v-if="result == null">Loading data...</div>

        <template v-if="result != null">
          <div class="no-data" v-if="result.totalRecords === 0">{{ tableLang['noData'] }}</div>
          <template v-for="record of result.records">
            <div :class="dataLoading ? 'data-loading' : ''">
              {{ formatDay(record.date) }}
            </div>
            <div :class="dataLoading ? 'data-loading' : ''">
              {{ record.share * 100 }}%
            </div>
            <div :class="dataLoading ? 'data-loading' : ''">
              {{ formatBigDollar(record.price) }}
            </div>
            <div :class="dataLoading ? 'data-loading' : ''">
              {{ formatBigDollar(record.deposit) }}
            </div>
          </template>
        </template>
      </div>
      <Page v-if="result != null" :page="result.page" :pages="result.totalPages" :click="(page) => setPage(page)"/>
    </div>
  </div>
</template>